/**
 * @desc 列表
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<ObjectMap>;
export function request(
  params: API.rms.expenseReimbursementDetail.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursementDetail/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
